import { NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, TemplateRef, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalContainerComponent } from '../modal-container/modal-container.component';

export interface InfoDialogData {
  customTemplate: TemplateRef<unknown>;
  header: string;
}

@Component({
  selector: 'shared-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, ModalContainerComponent, NgTemplateOutlet],
})
export class InfoDialogComponent implements AfterViewInit {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly dynamicDialogRef = inject(DynamicDialogRef);
  private readonly dynamicDialogConfig: DynamicDialogConfig<InfoDialogData> = inject(DynamicDialogConfig);

  protected readonly dialogData = this.dynamicDialogConfig.data;
  protected isDialogPositionUp = false;

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.isDialogPositionUp = true;
      this.changeDetectorRef.markForCheck();
    });
  }

  cancel(): void {
    this.dynamicDialogRef.close();
  }
}
